<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 二维码
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
           <img :src="img" alt="" >
            <div>
              <el-button @click="downloadCodeImg(img,'二维码',300,350)">下载</el-button>
            </div>
        </div>
       
        

    </div>
</template>
<script>

import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {
            id:"",
            img:'',
           companyid:''
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getData()
    },
    methods: {
         getUrlBase64(url,width,height) {
            return new Promise(resolve => {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let img = new Image()
            img.setAttribute('crossOrigin', 'anonymous');
            img.src = url + '?time=' + new Date().valueOf();
            img.onload = function() {
            canvas.height = img.height,
            canvas.width = img.width
            ctx.drawImage(img, 0, 0, img.width, img.height)
            let dataURL = canvas.toDataURL('image/png')
            canvas = null
            resolve(dataURL)
            }
            })
        },
        downloadCodeImg(url,name,width,height){
            this.getUrlBase64(url,width,height).then(base64 => {
                let link = document.createElement('a')
                link.href = base64
                link.download = name
                link.click()
            })
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('id',this.id)
            formdata.append('type','2')
            formdata.append('company_id',this.companyid)
            post('api/Onecode/code',formdata).then(res => {
                if(res.code=200){
                    this.img = res.data
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
      
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}
</style>
